﻿'use strict';

/** 
 * Factory for handling authorization of 
 * requests based on user roles
 * @namespace authorizationFactory
 */

authorizationFactory.$inject = ['$cookies', 'data_project_constants', 'connectionsFactory'];

function authorizationFactory($cookies, data_project_constants, connectionsFactory) {
    var service = {};

    var apiConnection = connectionsFactory.getApplicationAPIConnection(data_project_constants.endpoints.application_api);

    /**
    * Checks if user has the professor role 
    * @method authorizeProfessor
    * @returns {Boolean} isProfessor that tells if the user is a professor 
    * @memberOf components.authorizationModule.authorizationFactory
    */
    service.authorizeProfessor = function () {
        return $cookies.getObject(data_project_constants.cookies.user_is_professor_name);
    }

    service.setProfessorRole = function (isProfessor) {
        return apiConnection
                .all('userInfo/roles')
                .customGET()
                .then(function (result) {
                    var isProfessor = result.plain().isProfessor;

                    $cookies.putObject(data_project_constants.cookies.user_is_professor_name, isProfessor, { secure: true });
                });
    }

    return service;
}

module.exports = authorizationFactory;


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authorization/authorizationFactory.js
// module id = 23
// module chunks = 0